import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  sharedActions,
} from './store/actions';
import { GlJournalPropTypes } from './propTypes';

class AdminColumnRenderer extends PureComponent {
  static propTypes = {
    value: GlJournalPropTypes.isRequired,
    rowIndex: PropTypes.number.isRequired,

    showAddAndEdit: PropTypes.func.isRequired,
    showDelete: PropTypes.func.isRequired,
  };

  showAddEditModal = () => {
    const { value, showAddAndEdit } = this.props;

    return showAddAndEdit(value);
  };

  showDeleteModal = () => {
    const { value, rowIndex, showDelete } = this.props;

    return showDelete({ entity: value, rowIndex });
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit GL Journal"
          onClick={this.showAddEditModal}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete GL Journal"
          onClick={this.showDeleteModal}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default connect(
  null,
  {
    showAddAndEdit: sharedActions.showModalForAddEdit,
    showDelete: sharedActions.showModalForRemove,
  }
)(AdminColumnRenderer);
